import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classNames from 'classnames/bind';

import useCancelOrderModal from '../useCancelOrderModal';

// Components
import Modal from '../../Modal';
import Heading from '../../Heading';
import Button from '../../Button';
import CheckboxField from '../../CheckboxField';
import ToggleArrow from '../../ToggleArrow';
import Collapse from '../../Collapse';
import TextareaField from '../../TextareaField/DesktopView';

// Assets
import success from '../assets/success.svg';

// Styles
import styles from './CancelOrderModal.styl';

const cx = classNames.bind(styles);

export default function CancelOrderModal(props) {
  const { isOpen, onClose, order_id, onSuccessCallback } = props;

  const {
    reasons,
    currentReason,
    isToggleOpen,
    isLoading,
    isCancelled,
    onAccept,
    onCurrentReasonChange,
    onToggle,
    onOkeyClick,
  } = useCancelOrderModal({ order_id, onSuccessCallback, onClose });

  const intl = useIntl();

  return (
    <Modal
      className={cx('CancelOrderModal', { CancelOrderModal_cancelled: isCancelled })}
      isOpen={isOpen}
      onClose={onClose}
    >
      {isCancelled ? (
        <>
          <img className={cx('CancelOrderModal__img')} src={success} alt="success" />
          <Heading className={cx('CancelOrderModal__subtitle')} level={3}>
            {intl.formatMessage({ id: 'cancelOrder.subtitle' })}
          </Heading>
          <div className={cx('CancelOrderModal__success')}>
            {intl.formatMessage({ id: 'cancelOrder.success' })}
          </div>
          <Button className={cx('CancelOrderModal__okey')} onClick={onOkeyClick}>
            {intl.formatMessage({ id: 'button.understandably' })}
          </Button>
        </>
      ) : (
        <>
          <Heading className={cx('CancelOrderModal__title')} level={3}>
            {intl.formatMessage({ id: 'cancelOrder.title' })}
          </Heading>
          <div className={cx('CancelOrderModal__checkboxes')}>
            {reasons.map(reason => (
              <CheckboxField
                key={reason}
                className={cx('CancelOrderModal__checkbox')}
                label={reason}
                name={reason}
                value={currentReason === reason}
                onChange={() => onCurrentReasonChange(reason)}
              />
            ))}
          </div>
          <div className={cx('CancelOrderModal__comment')}>
            <button
              className={cx('CancelOrderModal__toggle')}
              onClick={onToggle}
              onKeyDown={e => e.key === 'Enter' && onToggle()}
              type="button"
            >
              {intl.formatMessage({ id: 'cancelOrder.toggle' })}
              <ToggleArrow className={cx('CancelOrderModal__arrow')} isOpen={isToggleOpen} />
            </button>
            <Collapse isOpen={isToggleOpen}>
              <TextareaField
                className={cx('CancelOrderModal__textarea')}
                placeholder={intl.formatMessage({ id: 'cancelOrder.textarea' })}
                name="comment"
                value={currentReason}
                onChange={e => onCurrentReasonChange(e.target.value)}
              />
            </Collapse>
          </div>
          <div className={cx('CancelOrderModal__actions')}>
            <Button
              className={cx('CancelOrderModal__accept')}
              onClick={onAccept}
              isLoading={isLoading}
              disabled={!currentReason}
            >
              {intl.formatMessage({ id: 'button.accept' })}
            </Button>
            <Button className={cx('CancelOrderModal__cancel')} onClick={onClose} link>
              {intl.formatMessage({ id: 'button.cancel' })}
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
}

CancelOrderModal.defaultProps = {
  onSuccessCallback: undefined,
};

CancelOrderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  order_id: PropTypes.number.isRequired,
  onSuccessCallback: PropTypes.func,
};
